<div
  [class.single-date]="singleDate"
  [ngClass]="singleDate && !confirmMode ? 'tw-w-full tw-gap-2 tw-p-3' : 'tw-w-80 tw-gap-2 tw-p-2'"
  class="tw-flex tw-flex-col tw-rounded-lg tw-bg-dt-surface-card tw-shadow-columns tw-border tw-border-color-border-subtle xxs:[zoom:0.85]"
>
  <!-- TEMP: w-96/p-6/gap-4/h-12/mat-calendar p-2 shrunk to fit the 660px cypress viewport
       (button was rendering below the fold). Revert once a design-approved fix lands. -->
  <!--  top-->
  @if (!singleDate || confirmMode) {
    <div class="tw-flex tw-flex-col tw-gap-1">
      <div class="tw-flex tw-justify-between">
        <div class="tw-flex tw-items-end">
          <span>{{ "jumpTo" | i18n }}</span>
        </div>
        <button
          class="tw-px-3 tw-py-2 tw-flex tw-items-center tw-justify-center tw-border tw-border-color-border-subtle tw-shadow-button hover:tw-bg-dt-surface-card tw-rounded-lg tw-text-color-text-secondary"
          (click)="resetDateRange()"
        >
          {{ "reset" | i18n }}
        </button>
      </div>
      <div class="tw-grid tw-grid-cols-3 tw-gap-2">
        <div class="tw-flex tw-justify-center tw-items-center">
          <app-input
            class="tw-w-full"
            [type]="'number'"
            [value]="relativeDateValue"
            [placeholder]="'number' | i18n"
            (outputValue)="setRelatedDateValue($event)"
            (blur)="updateRelativeDateRange()"
          >
          </app-input>
        </div>
        <div class="tw-flex tw-justify-center tw-items-center">
          <app-dropdown-select
            [selectedOption]="selectedDateUnit"
            [options]="dateUnitOptions"
            [sort]="'date'"
            (optionSelected)="selectDateUnit($event)"
            class="tw-w-full"
          >
          </app-dropdown-select>
        </div>
        <div class="tw-flex tw-justify-center tw-items-center">
          <app-dropdown-select
            [isEnabled]="false"
            [selectedOption]="selectedTimeDirection"
            [options]="timeDirectionOptions"
            (optionSelected)="selectTimeDirection($event)"
            class="tw-w-full"
          >
          </app-dropdown-select>
        </div>
      </div>
      <div class="tw-flex tw-gap-2 tw-text-color-text-secondary">
        <span>Reference to today:</span><span>{{ today | date: "yyyy-MM-dd" }}</span>
      </div>
    </div>
  }
  <!--  top end-->

  @if (showCalendar) {
    <mat-calendar
      #calendarRef
      class="tw-w-full tw-rounded-xl tw-border tw-border-color-border-subtle tw-bg-dt-surface-card tw-p-1 tw-shadow-calendar"
      [selected]="singleDate ? (confirmMode ? pendingDate : selectedDate) : dateRange"
      [dateFilter]="currentDateFilter"
      (selectedChange)="singleDate ? onSingleSelect($event) : rangeChanged($event)"
      [startAt]="getStartAt()"
    >
    </mat-calendar>
  } @else {
    <div
      class="tw-w-full tw-rounded-xl tw-border tw-border-color-border-subtle tw-bg-dt-surface-card tw-p-1 tw-shadow-calendar"
      [ngStyle]="{ height: calendarHeight }"
    ></div>
  }

  <!--  remove bg after the calendar bg change-->
  @if (!singleDate || confirmMode) {
    <div class="tw-flex tw-justify-between tw-items-center tw-gap-3">
      <button
        class="tw-h-10 tw-w-full tw-border tw-border-color-border-subtle tw-rounded-xl tw-shadow-calendar-new tw-bg-dt-surface-elevated tw-text-color-text-secondary"
        (click)="emitCancelEvent()"
      >
        Cancel
      </button>
      <button
        class="tw-h-10 tw-w-full tw-border tw-border-color-border-subtle tw-rounded-xl tw-shadow-calendar-new tw-bg-dt-surface-elevated tw-text-color-text-action"
        (click)="emitConfirmEvent()"
      >
        Confirm
      </button>
    </div>
  }
</div>
